export const CN_DOC_LINK =
  'https://nalotr1fui9.feishu.cn/wiki/RFIxwxJPuiwFvekoVAicUor6nOc?from=from_copylink';
export const CN_PURCHASE_LINK =
  'https://nalotr1fui9.feishu.cn/docx/TAKwdVDX0oO6hUxv17gcrGhhnhd?from=from_copylink';
